"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getContext(_ref) {
  var _ref$state = _ref.state,
      organisation = _ref$state.organisation,
      organisations = _ref$state.organisations,
      shootstaOrganisation = _ref$state.shootstaOrganisation,
      hasUpdatePermission = _ref$state.hasUpdatePermission,
      actions = _ref.actions;
  return {
    state: {
      organisation: organisation,
      organisations: organisations,
      shootstaOrganisation: shootstaOrganisation,
      hasUpdatePermission: hasUpdatePermission
    },
    actions: actions
  };
}

function contextHasChanges(newState, oldState) {
  return (0, _lodash.default)(getContext(newState), getContext(oldState));
}

var _default = (0, _memoizeOne.default)(getContext, contextHasChanges);

exports.default = _default;